import { useAssistantConversation } from "../../../modules/assistant/state/AssistantConversationProvider";
import { useAssistantConfig } from "../useAssistantConfig";
import { activityLabelFor } from "./Conversation";

/** Kit `CompanionStatusLine` — the one-line status shown under the
 * companion's name in the popover header. */
export function StatusLine() {
  const { messages, status } = useAssistantConversation();
  const { ai_available } = useAssistantConfig();

  const lastMessage = messages.at(-1);
  const activity = lastMessage?.role === "assistant" ? activityLabelFor(lastMessage) : null;
  const noText = lastMessage?.role === "assistant" && lastMessage.isStreaming && !lastMessage.content;

  const text = activity
    ? `${activity}…`
    : status === "streaming" && noText
      ? "Thinking…"
      : !ai_available
        ? "Not connected yet"
        : "Here to help plan your day";

  return <p className="text-xs text-slate-500">{text}</p>;
}
